export default "__VITE_ASSET__DY8vN7bQ__"